import { H3 } from "../ui/Heading";
import { ChatThread } from "../chat/ChatThread";
import type { Step } from "../data/steps";

export function StepRow({ step }: { step: Step }) {
  return (
    <div className="grid grid-cols-[120px_1fr_1fr] gap-12 items-center max-md:grid-cols-1 max-md:gap-9">
      <div className="font-display italic font-extrabold text-accent leading-none text-[96px] max-md:text-[64px]">
        {step.n}
      </div>
      <div>
        <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-td-3">
          STEP {step.n} · {step.title}
        </div>
        <H3 className="text-4xl leading-tight mt-3">{step.heading}</H3>
        <p className="mt-3.5 text-base leading-relaxed text-td-2">{step.body}</p>
      </div>
      <ChatThread messages={step.msgs} height={280} />
    </div>
  );
}
